import SkeletonAutogestion from "./SkeletonAutogestion";

export default SkeletonAutogestion;
